import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { IngredientService } from '../core/services/ingredient.service';
import { Ingredient } from '../shared/models/ingredient.model';
import { withEntitiesManagement } from './features/entities-management.feature';
import { inject } from '@angular/core';
import { SnackbarService } from '../core/services/snackbar.service';
import {
  setError,
  setLoaded,
  setLoading,
  withCallState,
} from '@angular-architects/ngrx-toolkit';

const collectionName = 'ingredientsImage';

export const IngredientsStore = signalStore(
  { providedIn: 'root' },
  withEntitiesManagement<Ingredient>(
    IngredientService,
    'ingredients',
    'ingredients'
  ),
  withCallState({ collection: collectionName }),
  withMethods(
    (
      store,
      ingredientService = inject(IngredientService),
      snackbarService = inject(SnackbarService)
    ) => ({
      initialize() {
        store.loadTotalCountFromDB();
      },
      generateImage(ingredientId: string) {
        patchState(store, setLoading(collectionName));

        ingredientService.generateImage(ingredientId).subscribe({
          next: (imageUrl) => {
            patchState(
              store,
              {
                selectedEntity: {
                  ...store.selectedEntity(),
                  imageUrl,
                },
              },
              setLoaded(collectionName)
            );
            snackbarService.show('Ingredient saved successfully', 'success');
          },
          error: (error) => {
            const errorMessage =
              error.error?.message || 'Failed to generate image for ingredient';
            snackbarService.show(errorMessage, 'error');
            console.error('Failed to generate image for ingredient', error);
            patchState(store, setError(errorMessage, collectionName));
          },
        });
      },
    })
  )
);
